export type UserClaim = {
  claimType: ClaimType;
  parentClaim?: ParentClaim;
  claimResource: ClaimResource;
  claimPermission: ClaimPermission;
};

export enum ClaimType {
  Default,
  Permission,
}

export enum ClaimPermission {
  Edit = "edit",
  Read = "read",
  Sync = "sync",
  Delete = "delete",
  SettingSync = "setting_sync",
  DesignationSync = "designation_sync",
  LocationSync = "location_sync",
  LicensureBodySync = "licensure_body_sync",
  View = "view",
  Repost = "repost",
  Approve = "approve",
  Archive = "archive",
  Enable = "enable",
}

export enum ParentClaim {
  Users = "users",
  Content = "content",
  Configuration = "configuration",
  Certificates = "certificates",
  Accreditation = "accreditation",
  Operations = "operations",
  Events = "events",
}

export enum ClaimResource {
  Id = "id",
  Role = "Role",
  Users = "users",
  UserAuditLog = "user_audit_log",
  GradeUserExams = "grade_exams",
  Roles = "roles",
  Products = "products",
  Skus = "skus",
  SkuFormats = "sku_formats",
  Series = "series",
  Evaluations = "evaluations",
  Questions = "questions",
  DynamicMenu = "dynamic_menu",
  ContentTemplates = "content_templates",
  Certificates = "certificates",
  CertificateTemplates = "certificate_templates",
  CertificateThemes = "certificate_themes",
  Imports = "imports",
  Requests = "requests",
  TestDataGeneration = "test_data_generation",
  Processes = "processes",
  SubmissionReport = "submission_report",
  Qualifications = "qualifications",
  Licenses = "licenses",
  RegexValidations = "regex_validations",
  LicenseRequirements = "license_requirements",
  LicenseTracker = "license_tracker",
  Wizards = "wizards",
  Resources = "resources",
  Organizations = "organizations",
  MediaLibrary = "media_library",
  ResourceLibraries = "resource_libraries",
  Rustici = "rustici",
  Settings = "settings",
  Notifications = "notifications",
  Emails = "emails",
  Agreements = "agreements",
  Attributes = "attributes",
  ContentBlocks = "content_blocks",
  E2eRegressionTests = "e2e_regression_tests",
  Webhooks = "webhooks",
  DataTools = "data_tools",
  DeveloperDashboard = "developer_dashboard",
}
